import { useNavigation } from '@rebuild/hooks/useNavigation';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

export const useMenuModuleClick = () => {
	const { goToModule } = useNavigation();
	const { viewModule } = useModuleNavigation();

	const handleModuleClick = (item, moduleData) => {
		if (!item?.moduleId) return;
		if (item.moduleId === 'company_profile') {
			viewModule('company_profile', {
				option: moduleData,
				isOwn: false
			});
			return;
		}
		goToModule(item.moduleId);
	};

	return { handleModuleClick };
};
